import { UsersTable } from '@app/domain/user/users-table/UsersTable';
import { ERole } from '@app/swagger-types';

export const UsersPage: React.VFC = () => {
  return <UsersTable role={ERole.ROLE_CUSTOMER} />;
};
